import { BlockHrefTargetEnum, BlockHrefTypeEnum, BlockNodeEnum, BlockTypeEnum } from '@core/enums';
import { BlockClassNameEnum } from '@core/enums/block-class-name.enum';
import { MediaInterface } from '@core/interfaces/media.interface';
import { MixedObject } from '@core/interfaces/mixed-object';
import { Stylable, Styles } from '@core/interfaces/styles/styles.interface';
import { BlockAction } from '@core/models/block-action.model';
import { BlockLink } from '@core/models/block-link.model';
import { BlockSettings } from '@core/models/block-settings.model';
import { sortMediaQueries } from '@shared/helpers/block-helpers';
import { cloneDeep } from 'lodash';

export class Block implements Stylable {
  [key: string]: any;

  id: number | null;
  uId = '';
  styles: Styles;
  type: BlockTypeEnum = BlockTypeEnum.UNIVERSAL_TYPE;
  node: BlockNodeEnum = BlockNodeEnum.DIV_NODE;
  content = '';
  isHtmlContent = false;
  customOrder = 0;
  children: Block[] = [];
  hrefType: BlockHrefTypeEnum | null = null;
  hrefTarget: BlockHrefTargetEnum | null = null;
  hrefUrl: string | null = null;
  hrefNoFollow = false;
  hrefAnchor: string | null;
  hrefQueryParams: MixedObject<string> | null;
  hrefDownload: boolean;
  hrefDownloadName: string | null = null;
  media: MediaInterface | null = null;
  image?: MediaInterface | null = null;
  additionalClasses: string[];
  imagePath: string;
  imageDimensions: { width: number; height: number };
  mediaAlt: string | null = null;
  settings: BlockSettings;
  specialBlockId: number;
  name: string;
  anchor: string | null;
  specialBlock: Block;
  specialBlockType: BlockTypeEnum | null = null;
  action: BlockAction = BlockAction.None;
  linkDescription: string;
  modelId: number;
  modelClass: BlockClassNameEnum;
  locale: string;
  useGrayPhotoPlaceholder?: boolean;
  useGrayPhotoPlaceholderForBgImage?: boolean;
  isVideoSnippet?: boolean;
  // append after construct
  link: BlockLink;
  tabindex: number;
  useAsButton = false;
  backgroundAnimation: any = null;

  constructor(data: Partial<Block>) {
    Object.assign(this, data);
    if (!this.content) {
      this.content = '';
    }

    // jeżeli nie mamy to tworzymy nowego
    if (!this.uId) {
      // this.uId = 'block_' + getRandomString();
      const str_id = (this.id || '')?.toString();
      // bierzemy pod uwagę, że ID może być w formacie naszego UID
      this.uId = str_id.startsWith('block_')
        ? str_id
        : 'block_' + str_id;
      console.log('Block u_id generate: ' + this.uId);
    }

    // nadpisujemy zainicjowane automatycznie
    // this.specialBlock = data.specialBlock ? new Block(data.specialBlock) : null;

    this.media = data.media ? data.media : null;
    if (this.image && typeof this.image === 'string') {
      this.image = {fullUrl: this.image, urls: {full: this.image}} as unknown as MediaInterface;
    }

    this.settings = new BlockSettings(data.settings);

    if (Array.isArray(this.styles)) {
      this.styles = {};
    }

    this.styles = sortMediaQueries(this.styles);
    this.link = new BlockLink({
      locale: data.locale,
      hrefType: data.hrefType,
      hrefTarget: data.hrefTarget,
      hrefUrl: data.hrefUrl,
      hrefAnchor: data.hrefAnchor,
      hrefNoFollow: data.hrefNoFollow,
      hrefQueryParams: data.hrefQueryParams,
      blockNode: data.node,
      linkDescription: data.linkDescription,
      hrefDownload: data.hrefDownload,
      hrefDownloadName: data.hrefDownloadName,
    });

    this.additionalClasses = data.additionalClasses || [];
  }

  static create(data: Partial<Block>): Block {
    return new Block(data);
  }

  clone(): Block {
    const clonedBlock = new Block({
      ...this,
      additionalClasses: [...this.additionalClasses],
      action: cloneDeep({...this.action}),
      link: new BlockLink(this.link),
      children: this.children.map((child) => child.clone()),
      specialBlock: this.specialBlock ? this.specialBlock.clone() : null,
    });
    clonedBlock.uId = this.uId;
    return clonedBlock;
  }
}
